<template>
  <painel-component :items="itemsOne">
    <error-component :errors="errors" v-if="showError" />

    <form v-if="viewPage">
      <row-component>
        <col-component
          class-col="col-xxl-8 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12"
          :class="{ formError: errors.client_id }"
        >
          <label>Cliente:</label>
          <div class="input-container">
            <input-component v-model="selectedClientName" placeholder="Cliente" disabled />
            <button-submit class="btn-modal-search" icon="search" @click="openModalClient = true" />
          </div>
        </col-component>

        <col-component
          class-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12"
          :class="{ formError: errors.freight_price }"
        >
          <label>Valor frete:</label>
          <input-component v-model="formData.freight_price" v-money="MONEY" />
        </col-component>
      </row-component>

      <row-component>
        <col-component
          class-col="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
          :class="{ formError: errors.description }"
        >
          <label>Descrição:</label>
          <text-area v-model="formData.description" rows="6" />
        </col-component>
      </row-component>

      <row-component>
        <col-component class-col="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
          <button-route class="w-100" :items="itemsTwo" />
        </col-component>

        <col-component class-col="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
          <button-submit :disabled="sendForm" @click="submit" class="w-100" icon="plus" name="Adicionar" />
        </col-component>
      </row-component>
    </form>

    <OrderPartClientSearch
      v-if="openModalClient"
      @close="openModalClient = false"
      @select="handleClientSelection"
    />
  </painel-component>
</template>

<script>
import PainelComponent from '@/components/dashboard/PainelComponent';
import RowComponent from '@/components/row/RowComponent';
import ColComponent from '@/components/row/ColComponent';
import InputComponent from '@/components/form/InputComponent';
import TextArea from '@/components/form/TextArea';
import ButtonSubmit from '@/components/buttons/ButtonSubmit';
import ButtonRoute from '@/components/buttons/ButtonRoute';
import ErrorComponent from '@/components/alerts/ErrorComponent';
import OrderPartClientSearch from '@/components/modal/OrderPartClientSearch.vue';

import { VMoney } from 'v-money';
import { MONEY } from '@/configs/constants';
import { useToast } from 'vue-toastification';

const toast = useToast();
export default {
  name: 'OrderPartCreate',

  components: {
    ErrorComponent,
    ButtonRoute,
    ButtonSubmit,
    TextArea,
    InputComponent,
    ColComponent,
    RowComponent,
    PainelComponent,
    OrderPartClientSearch
  },

  directives: {
    money: VMoney
  },

  created() {
    this.$store.dispatch('changeNamePage', 'Pedido');
    this.checkACL();
  },

  data() {
    return {
      itemsOne: {
        title: 'Adicionar',
        icon: 'pen square'
      },

      itemsTwo: {
        route: '/order-part/search',
        icon: 'reply all',
        name: 'Voltar'
      },

      formData: {
        client_id: '',
        freight_price: '0,00',
        description: ''
      },

      MONEY,
      selectedClientName: '',
      openModalClient: false,
      errors: [],
      viewPage: false,
      sendForm: false,
      showError: false
    };
  },

  methods: {
    submit() {
      if (!this.sendForm) {
        this.sendForm = true;
        this.$store
          .dispatch('storeOrderPart', this.formData)
          .then(r => {
            this.showError = false;
            this.sendForm = false;
            this.errors = [];
            toast.success('Cadastro efetuado com sucesso', { timeout: 1500 });
            this.$router.push({ name: 'order-part-edit', params: { id: r } });
          })
          .catch(e => {
            this.showError = true;
            this.sendForm = false;
            window.scroll(0, 0);
            this.errors = e.response.data.errors;
          });
      }
    },

    handleClientSelection(client) {
      this.formData.client_id = client.id;
      this.selectedClientName = client.surname || client.name;
      this.openModalClient = false;
    },

    async checkACL() {
      this.$store
        .dispatch('ACLItems', 8)
        .then(r => {
          if (r.indexOf('order-part-create') !== -1) {
            this.viewPage = true;
          } else {
            this.$router.push({ name: 'home' });
          }
        })
        .catch(() => {
          this.$router.push({ name: 'home' });
        });
    }
  }
};
</script>

<style scoped>
.input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.btn-modal-search {
  padding-top: 9.5px;
  padding-bottom: 5px;
}
</style>
